import { render, staticRenderFns } from "./contract_hotel_card.vue?vue&type=template&id=984af220&"
import script from "./contract_hotel_card.vue?vue&type=script&lang=js&"
export * from "./contract_hotel_card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports